module.exports = __webpack_public_path__ + "static/media/395.8bf0451e.svg";